import { useEffect, useState } from "react";
import useDomainStore from "../../stores/domain";
import useUserStore from "../../stores/user";

export function useOrganizationLogo() {
  const user = useUserStore((state) => state.user);
  const { isKurvDomain } = useDomainStore();
  const [orgLogoFull, setOrgLogoFull] = useState(null);
  const [orgLogoIcon, setOrgLogoIcon] = useState(null);

  useEffect(() => {
    if (isKurvDomain) {
      setOrgLogoFull("/images/kurv/kurv-logo.svg");
      setOrgLogoIcon("/images/kurv/kurv-favicon.svg");
    } else if (user?.organization?.whitelabel_slug) {
      const slug = user.organization.whitelabel_slug;
      setOrgLogoFull(`/img/${slug}/logo-solid.png`);
      setOrgLogoIcon(`/img/${slug}/logo-solid.png`);
    }
  }, [user, isKurvDomain]);

  return { orgLogoFull, orgLogoIcon };
}
